const API_URL = process.env.REACT_APP_API_URL; // Load API URL from .env file
//const API_URL = "https://localhost:44331/"; // IIS Express
//const API_URL = "http://localhost:5069/"; // Kestrel

// export async function get(url) {
//   const response = await fetch(API_URL + url);
//   if (!response.ok) {
//     throw new Error(`GET request failed: ${response.status}`);
//   }
//   return await response.json();
// }

// need {credentials: "include"} to avoid 401 (Unauthorize) error on secured endpoints 


//const token = JSON.parse(localStorage.getItem('authUserToken'));
//const token = localStorage.getItem('authUserToken');

//console.log('localStorage: ' + localStorage.getItem('authUserToken'));
//console.log('JSON.parse: ' + JSON.parse(localStorage.getItem('authUserToken')));
//console.log('token: ' + token);

export async function get(url, config = { mode: "cors", credentials: "include", headers: {"Content-Type": "application/json"}}) {
  const response = await fetch(API_URL + url, { ...config });
  if (!response.ok) {
    throw new Error(`GET request failed: ${response.status}`);
  }
  return await response.json();
}

// export async function getJwt(url, config = { mode: "cors", credentials: "include", headers: {"Content-Type": "application/json" }}) {
//   console.log('token: ', localStorage.getItem('authUserToken'));
//   let token = localStorage.getItem('authUserToken');
//   const response = await fetch(API_URL + url, { 
//     ...config,
//     headers: {
//       ...config.headers,
//       Authorization: `Bearer ${token}`
//   } 

//   });
//   if (!response.ok) {
//     throw new Error(`GET request failed: ${response.status}`);
//   }
//   return await response.json();
// }

export async function getJwt(url, params = {}, config = { mode: "cors", 
                            // Nick J - Security Disabled - Uncomment credentials to enable security and send bearer token to backend API
                            //credentials: "include", 
                             headers: { "Content-Type": "application/json" } }) {
  console.log('token: ', localStorage.getItem('authUserToken'));
  let token = localStorage.getItem('authUserToken');

  // Construct query string from params
  // const queryString = Object.keys(params).length ? `?${new URLSearchParams(params).toString()}` : '';

  const queryString = Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== '') // Include only params with a value
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`) // Encode keys and values
    .join('&'); // Join them with '&'

  const fullQueryString = queryString ? `?${queryString}` : '';

  console.log('Call Api: ' + url + fullQueryString);

  const response = await fetch(API_URL + url + fullQueryString, {
    ...config,
    headers: {
      ...config.headers,
      // Nick J -Security Disabled - Uncomment Authorization to enable security and send bearer token to backend API
      //Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    // failed response might not contain valid json - handle all cases (string, null)
    let errorMessage = `GET request failed: ${response.status}`;
    try {
      const errorData = await response.json();
      if (errorData && errorData.message) {
        errorMessage = errorData.message;
      }
    } catch {
      // fallback: handler when backend sometimes returns non-JSON (like plain text or HTML)
      try {
        const errorText = await response.text();
        if (errorText) errorMessage = errorText;
      } catch {}
    }
    throw new Error(errorMessage);
  }

  // successfull response might not contain valid json - handle all cases
  let results;
  try {
    results = await response.json();
  } catch {
    // If response is not JSON (e.g., empty or plain text), fallback to text or null
    try {
      results = await response.text();
    } catch {
      results = null;
    }
  }
  return results;
}

// export async function post(url, data, config = { method: "POST", body: JSON.stringify(data), mode: "cors", credentials: "include", headers: {"Content-Type": "application/json"}}) {
//   const response = await fetch(API_URL + url, { ...config, body: JSON.stringify(data) });
//   if (!response.ok) {
//     throw new Error(`POST request failed: ${response.status}`);
//   }
//   return await response.json();
// }

export async function post(url, data, config = { method: "POST", mode: "cors", 
                                                // Nick J - Security Disabled - Uncomment credentials to enable security and send bearer token to backend API
                                                //credentials: "include", 
                                                headers: { "Content-Type": "application/json" } }) {
  console.log("Test Request Payload:", data); // Log the request payload
  const response = await fetch(API_URL + url, { ...config, body: JSON.stringify(data) });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || `POST request failed: ${response.status}`);
  }
  return await response.json();
}

export async function postJwt(url, data, config = { method: "POST", mode: "cors", 
                                                    // Nick J - Security Disabled - Uncomment credentials to enable security and send bearer token to backend API
                                                    //credentials: "include", 
                                                    headers: { "Content-Type": "application/json" } }) {
  console.log("Test Request Payload:", data); // Log the request payload
  let token = localStorage.getItem('authUserToken');
  const response = await fetch(API_URL + url, { 
    ...config, 
    headers: {
     "Content-Type": "application/json", // Always set this!
      ...(config.headers || {}),
      // Nick J -Security Disabled - Uncomment Authorization to enable security and send bearer token to backend API
      //Authorization: `Bearer ${token}`,
  }, 
    body: JSON.stringify(data) 
  });


  if (!response.ok) {
    // failed response might not contain valid json - handle all cases (string, null)
    let errorMessage = `POST request failed: ${response.status}`;
    try {
      const errorData = await response.json();
      if (errorData && errorData.message) {
        errorMessage = errorData.message;
      }
    } catch {
      // fallback: handler when backend sometimes returns non-JSON (like plain text or HTML)
      try {
        const errorText = await response.text();
        if (errorText) errorMessage = errorText;
      } catch {}
    }
    throw new Error(errorMessage);
  }

  // successfull response might not contain valid json - handle all cases
  let results;
  try {
    results = await response.json();
  } catch {
    // If response is not JSON (e.g., empty or plain text), fallback to text or null
    try {
      results = await response.text();
    } catch {
      results = null;
    }
  }
  return results;
}


// export async function post(url, data, config = {}) {
//   const response = await fetch(API_URL + url, {
//     mode: "cors",
//     method: "POST",
//     credentials: "include",
//     body: JSON.stringify(data),
//     headers: {
//       "Content-Type": "application/json",
//       ...config.headers,
//     },
//     ...config,
//   });
//   if (!response.ok) {
//     throw new Error(`POST request failed: ${response.status}`);
//   }
//   return await response.json();
// }


export async function putJwt(url, data, config = { method: "PUT", mode: "cors", 
                                                    // Nick J - Security Disabled - Uncomment credentials to enable security and send bearer token to backend API
                                                    //credentials: "include", 
                                                    headers: { "Content-Type": "application/json" } }) {
  console.log("Test Request Payload:", data); // Log the request payload
  let token = localStorage.getItem('authUserToken');
  const response = await fetch(API_URL + url, { 
    ...config, 
    headers: {
     "Content-Type": "application/json", // Always set this!
      ...(config.headers || {}),
      // Nick J -Security Disabled - Uncomment Authorization to enable security and send bearer token to backend API
      //Authorization: `Bearer ${token}`,
  }, 
    body: JSON.stringify(data) 
  });


  if (!response.ok) {
    // failed response might not contain valid json - handle all cases (string, null)
    let errorMessage = `POST request failed: ${response.status}`;
    try {
      const errorData = await response.json();
      if (errorData && errorData.message) {
        errorMessage = errorData.message;
      }
    } catch {
      // fallback: handler when backend sometimes returns non-JSON (like plain text or HTML)
      try {
        const errorText = await response.text();
        if (errorText) errorMessage = errorText;
      } catch {}
    }
    throw new Error(errorMessage);
  }

  // successfull response might not contain valid json - handle all cases
  let results;
  try {
    results = await response.json();
  } catch {
    // If response is not JSON (e.g., empty or plain text), fallback to text or null
    try {
      results = await response.text();
    } catch {
      results = null;
    }
  }
  return results;
}

export async function   put(url, data, config = {}) {
  const response = await fetch(API_URL + url, {
    mode: "cors",
    method: "PUT",
    credentials: "include",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin':'*',
      ...config.headers,
    },
    ...config,
  });
  if (!response.ok) {
    throw new Error(`PUT request failed: ${response.status}`);
  }
  return await response.json();
}

export async function del(url, config = {}) {
  const response = await fetch(API_URL + url, { method: "DELETE", ...config });
  if (!response.ok) {
    throw new Error(`DELETE request failed: ${response.status}`);
  }
  return await response.json();
}

export async function deleteJwt(url, data, config = { method: "DELETE", mode: "cors", 
                                                      // Nick J - Security Disabled - Uncomment credentials to enable security and send bearer token to backend API
                                                      //credentials: "include", 
                                                      headers: { "Content-Type": "application/json" } }) {
  //console.log("Test Request Payload:", data); // Log the request payload
  let token = localStorage.getItem('authUserToken');
  const response = await fetch(API_URL + url, { 
    ...config, 
    headers: {
     "Content-Type": "application/json", // Always set this!
      ...(config.headers || {}),
      Authorization: `Bearer ${token}`
  }, 
    body: JSON.stringify(data) 
  });


  if (!response.ok) {
    // failed response might not contain valid json - handle all cases (string, null)
    let errorMessage = `DELETE request failed: ${response.status}`;
    try {
      const errorData = await response.json();
      if (errorData && errorData.message) {
        errorMessage = errorData.message;
      }
    } catch {
      // fallback: handler when backend sometimes returns non-JSON (like plain text or HTML)
      try {
        const errorText = await response.text();
        if (errorText) errorMessage = errorText;
      } catch {}
    }
    throw new Error(errorMessage);
  }

  // successfull response might not contain valid json - handle all cases
  let results;
  try {
    results = await response.json();
  } catch {
    // If response is not JSON (e.g., empty or plain text), fallback to text or null
    try {
      results = await response.text();
    } catch {
      results = null;
    }
  }
  return results;
}


// //test windows authentication - https://www.seeleycoder.com/blog/windows-authentication-with-react/
// export const getUserTest = (url) => {
//   let request = Object.assign({}, requestBase, { method: "GET" });
//   //let api_url = `${url}`;

//   return fetch(API_URL + url, request).then(handleResponse);
// }

// export const handleResponse = (response) => {
//   return response.text().then((text) => {
//     const data = text && JSON.parse(text);
//     if (!response.ok) {
//       const error = (data && data) || response.statusText;
//       return Promise.reject(error);
//     }

//     return data;
//   });
// };

// export const requestBase = (() => {
//   if (typeof window !== "undefined") {
//     return {
//       method: "POST",
//       credentials: "include",
//       mode: 'cors',
//       headers: new Headers({
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       }),
//     };
//   } else
//     return {
//       method: "POST",
//       credentials: "include",
//       // mode: 'cors',
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       },
//     };
// })();
